
import { Component, Input, OnInit } from '@angular/core';

import { ViewCell } from 'ng2-smart-table';

@Component({
  template: `
    {{renderValue }}
  `,
})
export class CustomRenderNumberOfChildrenComponent implements ViewCell, OnInit {

  renderValue: number;

  @Input() value: any;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue = this.value && this.value.length
  }

}